// ** React Imports
import { useContext, useEffect, useState } from 'react'

import { TOKEN_KEY } from '../../../../assets/auth/auth'
import { PermissionProvider } from '../../../../Helper/Context'
import Cookies from 'js-cookie'
import { getReq, omcDomain } from '../../../../assets/auth/jwtService'

export const logoutFromDomains = () => {
  const domains = [
    `${omcDomain}/userLogout`,
    'https://dom3.com/userLogout'
  ]
  domains.forEach(url => {
    const iframe = document.createElement('iframe')
    iframe.style.display = 'none'
    iframe.src = url
    document.body.appendChild(iframe)
    console.log("iframe", iframe)
  })
  Cookies.remove(TOKEN_KEY)
  Cookies.remove('superUser')
  localStorage.removeItem("userPermission")
  localStorage.removeItem("whatsappUserPermission")
}
const UserDropdown = () => {
  // const [outletData, setOutletData] = useState([])
  const { userPermission } = useContext(PermissionProvider)
  const [data, setData] = useState({
    accDetails: {},
    firstName: "",
    lastName: "",
    user_email: ""
  })

  // const removePermision = () => {
  //   setUserPermission({
  //     appName: '',
  //     multipleDomain: [],
  //     apiKey: '',
  //     installedApps: [],
  //     campaign: []
  //   })
  // }

  const getData = () => {
    getReq('accDetails')
      .then((res) => {
        const updatedData = {
          accDetails: res?.data?.data?.merchant_profile,
          firstName: res?.data?.data?.merchant_profile?.first_name,
          lastName: res?.data?.data?.merchant_profile?.last_name,
          user_email: res?.data?.data?.merchant_profile?.user_email
        }
        setData((pre) => ({
          ...pre,
          ...updatedData
        }))
      })
      .catch((err) => {
        console.log(err)
      })
  }

  // console.log(userPermission, "userPermission")
  // const getData = () => {
  //   getReq('saveOutletDetails')
  //   .then((data) => data.json())
  //   .then((resp) => {
  //     setOutletData(resp.data.data.outlet_detail)
  //   })
  //   .catch((error) => {
  //     console.log(error)
  //   })
  // }

  useEffect(() => {
    getData()
  }, [])

  return (
    <li className='nav-item'>
      <div className='d-flex justify-between' style={{ cursor: 'default' }}>
        <div className='d-sm-flex flex-column d-none' >
          <span className='user-name fw-bold text-capitalize' style={{ whiteSpace: 'nowrap' }}>
            {userPermission?.logged_in_user?.user_first_name}
          </span>
          {<span className='user-status' style={{ whiteSpace: 'nowrap' }}>{userPermission?.logged_in_user?.user_role}</span>}
        </div>
        {/* <Avatar img={defaultAvatar} imgHeight='40' imgWidth='40' status='online' /> */}
        <span className='d-flex justify-content-center align-items-center' style={{ width: '40px', height: '40px', borderRadius: '6000px', fontSize: "100%", color: "white", backgroundColor: "#7367f0", textTransform: 'uppercase' }}>
          {
            data?.firstName && data?.lastName ? `${data?.firstName[0]}${data?.lastName[0]}` : data?.user_email[0]
          }
        </span>
      </div>
    </li>
  )
}

export default UserDropdown
